import { Switch } from 'antd'

/**
 * 开关组件
 *
 * 这是一个基于Ant Design Switch封装的开关组件，用于表示两种状态之间的切换。
 * 支持自定义大小、禁用状态等属性，适用于各种开关控制场景。
 *
 * @param checked - 指定当前是否选中
 * @param onChange - 变化时的回调函数，参数为新的选中状态
 * @param props - 其他传递给Switch组件的属性
 *
 * 使用场景：
 * 1. 功能开关 - 各种功能的开启/关闭控制
 * 2. 设置选项 - 用户设置中的开关选项
 * 3. 状态切换 - 数据状态的开启/关闭切换
 * 4. 权限控制 - 权限的启用/禁用控制
 * 5. 通知设置 - 通知功能的开启/关闭
 * 6. 自动保存 - 自动保存功能的开关
 * 7. 夜间模式 - 深色/浅色主题切换
 * 8. 数据同步 - 数据同步功能的开关
 *
 * 使用示例：
 * ```tsx
 * // 基础用法
 * const [isChecked, setIsChecked] = useState(false)
 *
 * <SwitchComponent
 *   checked={isChecked}
 *   onChange={(checked) => setIsChecked(checked)}
 * />
 *
 * // 带大小设置
 * <SwitchComponent
 *   checked={isEnabled}
 *   onChange={handleToggle}
 *   size="large"
 * />
 *
 * // 禁用状态
 * <SwitchComponent
 *   checked={isActive}
 *   onChange={handleChange}
 *   disabled={!hasPermission}
 * />
 *
 * // 带文字描述
 * <div>
 *   <span>自动保存</span>
 *   <SwitchComponent
 *     checked={autoSave}
 *     onChange={setAutoSave}
 *   />
 * </div>
 * ```
 */
const SwitchComponent = ({ checked, onChange, ...props }) => {
  return <Switch checked={checked} onChange={onChange} {...props} />
}

export default SwitchComponent
